import { render, staticRenderFns } from "./NoticiasMercadoMeusFavoritos.vue?vue&type=template&id=1ce8b446&"
import script from "./NoticiasMercadoMeusFavoritos.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoMeusFavoritos.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoMeusFavoritos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports